import { jsx as _jsx } from "react/jsx-runtime";
import { useFeaturesEnabled } from "@/contexts/cdpConfig/hooks";
import { useI18n } from "@/shared/hooks";
import { SALUTATION } from "@/types";
import { RadioGroup } from "@gemini/ui";
import { useEffect } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { salutationInputTestId } from "./constants";
export const SalutationInput = ({ control }) => {
    const { t } = useI18n();
    const { setValue } = useFormContext();
    const { hideSalutationField } = useFeaturesEnabled();
    useEffect(() => {
        // Explicitly set the salutation when shouldHideSalutation=true,
        // as the field value would not be set otherwise since it is not rendered,
        // and therefore the form context is not updated.
        if (hideSalutationField) {
            setValue("salutation", SALUTATION.DIVERSE);
        }
    }, [setValue, hideSalutationField]);
    if (hideSalutationField)
        return;
    return (_jsx(Controller, { name: "salutation", control: control, defaultValue: SALUTATION.DIVERSE, render: ({ field: { value, onChange, name }, fieldState: { error } }) => {
            return (_jsx(RadioGroup, { testId: salutationInputTestId, hasNecessityIndicator: false, direction: "horizontal", onChange: onChange, value: value, items: [
                    {
                        value: SALUTATION.MR,
                        label: t("contact.form.salutation_he"),
                    },
                    {
                        value: SALUTATION.MRS,
                        label: t("contact.form.salutation_she"),
                    },
                    {
                        value: SALUTATION.DIVERSE,
                        label: t("contact.form.salutation_diverse"),
                    },
                ], label: t("contact.form.salutation"), error: error === null || error === void 0 ? void 0 : error.message, name: name }));
        } }));
};
